import { IApplicationData } from "./common";
export class ChatGPT implements IApplicationData {
  constructor() {
    this.name = "Virtual Agent";
    this.audioId = "";
    this.audioPath = "";
    this.audioNoInputId = "";
    this.audioNotMatchId = "";
    this.audioNotMatchPath = "";
    this.audioNoInputPath = "";
    this.text = "";
    this.textChatBot = "";
    this.textNotMatch = "";
    this.textNoInput = "";
    this.content = "";
    this.contentChatBot = "";
    this.contentNotMatch = "";
    this.contentNoInput = "";
    this.option = 1;
    this.idGrammar = 0;
    this.attribute = "";
    this.directory = "";
    this.datasetName = "";
    this.idDataset = "";
    this.multipleOtherCase = true;
    this.transition = true;
    this.type = "";
    this.timeout = "10";
    this.noInputTimeout = "5";
    this.minLength = "1";
    this.maxLength = "200";
    this.log = false;
    this.repeat = "2";
    this.grammarName = "";
    this.entity = "";
    this.entityAttribute = "";
    this.engine = true;
    this.extenData = "";
    this.grammar = "";
    this.grammarArray = "[]";
    this.beforeCustomFunctions = "[]";
    this.afterCustomFunctions = "[]";
    this.intentQA = "";
    this.enableCheckpoint = true;
    this.customTrain = false;
    this.sentiment = "";
    this.prompt = "Assuming IT support";
    this.sentimentMain = "";
    this.sentimentNoInput = "";
    this.sentimentNotMatch = "";
    this.responseMode = "ONLY_DOC";
    this.temperature = 0.3;
    this.numberOutput = 512;
    this.multipleCase = true;
    this.userResponse = "";
    this.isRequired = true;
    this.checkFields = true;
    this.keepContext = false;
    this.multipleTransition = true;
    this.multipleOptionCase = true;
    this.answer = "";
    this.allowAnswerOption = false;
    this.answerCustom = "";
    this.answerOptionType = 1;
    this.llmModel = "gpt-4o-mini";
    this.topP = 1;
    this.frequencyPenalty = 0;
    this.presencePenalty = 0;
    this.topK = 3;
    this.similarityCutOff = 50;
    this.replyType = "default";
    this.interruptAction = "allow";
    this.language = "";
  }
  name: string;
  audioPath: string;
  audioId: string;
  functionId: string;
  audioNotMatchId: string;
  audioNoInputId: string;
  audioNotMatchPath: string;
  grammar: string;
  audioNoInputPath: string;
  text: string;
  textChatBot: string;
  textNotMatch: string;
  textNoInput: string;
  content: string;
  contentChatBot: string;
  contentNotMatch: string;
  contentNoInput: string;
  datasetName: string;
  idDataset: string;
  idGrammar: number;
  attribute: string;
  directory: string;
  multipleOtherCase: boolean;
  transition: boolean;
  type: string;
  option: number;
  timeout: string;
  noInputTimeout: string;
  minLength: string;
  maxLength: string;
  log: boolean;
  repeat: string;
  entity: string;
  grammarName: string;
  entityAttribute: string;
  engine: boolean;
  extenData: string;
  intentQA: string;
  enableCheckpoint: boolean;
  prompt: string;
  customTrain: boolean;
  sentiment: string;
  sentimentMain: string;
  sentimentNoInput: string;
  sentimentNotMatch: string;
  temperature: number;
  responseMode: string;
  numberOutput: number;
  multipleCase: boolean;
  userResponse: string;
  grammarArray: string;
  afterCustomFunctions: string;
  beforeCustomFunctions: string;
  isRequired: boolean;
  checkFields: boolean;
  keepContext: boolean;
  multipleTransition: boolean;
  multipleOptionCase: boolean;
  answer: string;
  allowAnswerOption: boolean;
  answerCustom: string;
  answerOptionType: number;
  llmModel: string;
  topP: number;
  frequencyPenalty: number;
  presencePenalty: number;
  topK: number;
  similarityCutOff: number;
  replyType: string;
  language: string;
  interruptAction: string;
}
